module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ190E1LX75T-6-23-15.319930c3.pdf";